<script>
  import {headerBreakPoint} from "@util/constant"
  import LargeHeader from "./LargeHeader.svelte";
  import SmallHeader from "./SmallHeader.svelte";
  let y
</script>

<svelte:window bind:innerWidth={y} />

<div class="header-container">
{#if y > headerBreakPoint}
<LargeHeader />
{:else}
<SmallHeader />
{/if}
</div>


<style>

  .header-container {
    position: relative;
    z-index: 3;
  }

</style>
